import { accessControlsConstants } from "../_constants";
import { accessControlsServices } from "../_services";
import { alertActions } from ".";

export const accessControlsActions = {
  createAccessControl,
  getAccessControlsDetails,
  getAccessControlsList,
  getActiveRoleList,
  getAccessControlsPolicesList,
  applyAccessControlsFilters,
  getAccessControlsTopCard,
  getAccessControlsFilters,
  assignAccessControlPolicies,
  activateAccessRole,
  updateAccessControl,
  deleteRole,
  fetchAllUiNavigation,
  assignUiNavigation,
  UiNavigationById,
  fetchPoliciesById,
  unassignUiNavigation,
  searchAccessControls
};

function createAccessControl(formData) {
  return (dispatch) => {
    dispatch(request());
    accessControlsServices.createAccessControl(formData).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: accessControlsConstants.CREATE_NEW_ACCESS_CONTROL_REQUEST };
  }
  function success(data) {
    return {
      type: accessControlsConstants.CREATE_NEW_ACCESS_CONTROL_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: accessControlsConstants.CREATE_NEW_ACCESS_CONTROL_FAILURE,
      error,
    };
  }
}

function assignAccessControlPolicies(polices, accessControlId) {
  return (dispatch) => {
    dispatch(request());
    accessControlsServices
      .assignAccessControlPolicies(polices, accessControlId)
      .then(
        (accessControlPolices) => {
          dispatch(success(accessControlPolices));
          dispatch(
            alertActions.success(accessControlPolices.message)
          );
        },
        (error) => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()));
        }
      );
  };
  function request() {
    return {
      type: accessControlsConstants.ACCESS_CONTROL_POLICIES_UPDATE_REQUEST,
    };
  }
  function success(accessControlPolices) {
    return {
      type: accessControlsConstants.ACCESS_CONTROL_POLICIES_UPDATE_SUCCESS,
      accessControlPolices,
    };
  }
  function failure(error) {
    return {
      type: accessControlsConstants.ACCESS_CONTROL_POLICIES_UPDATE_FAILURE,
      error,
    };
  }
}

function getAccessControlsPolicesList(roleId) {
  return (dispatch) => {
    dispatch(request());
    accessControlsServices.getAccessControlsPolicesList(roleId).then(
      (accessControlPolicies) => dispatch(success(accessControlPolicies)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return {
      type: accessControlsConstants.GET_ACCESS_CONTROL_POLICIES_REQUEST,
    };
  }
  function success(accessControlPolicies) {
    return {
      type: accessControlsConstants.GET_ACCESS_CONTROL_POLICIES_SUCCESS,
      accessControlPolicies,
    };
  }
  function failure(error) {
    return {
      type: accessControlsConstants.GET_ACCESS_CONTROL_POLICIES_FAILURE,
      error,
    };
  }
}

function getAccessControlsFilters() {
  return (dispatch) => {
    dispatch(request());
    accessControlsServices.getAccessControlsFilters().then(
      (filtersAccessControl) => dispatch(success(filtersAccessControl)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: accessControlsConstants.GET_ACCESS_CONTROL_FILTER_REQUEST };
  }
  function success(filtersAccessControl) {
    return {
      type: accessControlsConstants.GET_ACCESS_CONTROL_FILTER_SUCCESS,
      filtersAccessControl,
    };
  }
  function failure(error) {
    return {
      type: accessControlsConstants.GET_ACCESS_CONTROL_FILTER_FAILURE,
      error,
    };
  }
}

function getAccessControlsDetails(accessControlId) {
  return (dispatch) => {
    dispatch(request());
    accessControlsServices.getAccessControlsDetails(accessControlId).then(
      (accessControl) => dispatch(success(accessControl)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return {
      type: accessControlsConstants.GET_ACCESS_CONTROL_DETAILS_REQUEST,
    };
  }
  function success(accessControl) {
    return {
      type: accessControlsConstants.GET_ACCESS_CONTROL_DETAILS_SUCCESS,
      accessControl,
    };
  }
  function failure(error) {
    return {
      type: accessControlsConstants.GET_ACCESS_CONTROL_DETAILS_FAILURE,
      error,
    };
  }
}

function applyAccessControlsFilters(
  type,
  user,
  status,
  startDate,
  endDate,
  search,
  offset,
  limit
) {
  return (dispatch) => {
    dispatch(request());
    accessControlsServices
      .applyAccessControlsFilters(
        type,
        user,
        status,
        startDate,
        endDate,
        search,
        offset, 
        limit
      )
      .then(
        (accessControls) => dispatch(success(accessControls)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: accessControlsConstants.GETALL_ACCESS_CONTROLS_REQUEST };
  }
  function success(accessControls) {
    return {
      type: accessControlsConstants.GETALL_ACCESS_CONTROLS_SUCCESS,
      accessControls,
    };
  }
  function failure(error) {
    return {
      type: accessControlsConstants.GETALL_ACCESS_CONTROLS_FAILURE,
      error,
    };
  }
}

function getAccessControlsTopCard() {
  return (dispatch) => {
    dispatch(request());
    accessControlsServices.getAccessControlsTopCard().then(
      (accessControlsTopCardInfo) =>
        dispatch(success(accessControlsTopCardInfo)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return {
      type: accessControlsConstants.GET_ACCESS_CONTROL_TOP_CARD_INFO_REQUEST,
    };
  }
  function success(accessControlsTopCardInfo) {
    return {
      type: accessControlsConstants.GET_ACCESS_CONTROL_TOP_CARD_INFO_SUCCESS,
      accessControlsTopCardInfo,
    };
  }
  function failure(error) {
    return {
      type: accessControlsConstants.GET_ACCESS_CONTROL_TOP_CARD_INFO_FAILURE,
      error,
    };
  }
}

function getAccessControlsList(offset, limit) {
  return (dispatch) => {
    dispatch(request());
    accessControlsServices.getAccessControlsList(offset, limit).then(
      (accessControls) => dispatch(success(accessControls)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: accessControlsConstants.GETALL_ACCESS_CONTROLS_REQUEST };
  }
  function success(accessControls) {
    return {
      type: accessControlsConstants.GETALL_ACCESS_CONTROLS_SUCCESS,
      accessControls,
    };
  }
  function failure(error) {
    return {
      type: accessControlsConstants.GETALL_ACCESS_CONTROLS_FAILURE,
      error,
    };
  }
}

function getActiveRoleList(offset, limit) {
  return (dispatch) => {
    dispatch(request());
    accessControlsServices.getActiveRoleList(offset, limit).then(
      (activeRoles) => dispatch(success(activeRoles)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: accessControlsConstants.GETALL_ACTIVE_ROLES_REQUEST };
  }
  function success(activeRoles) {
    return {
      type: accessControlsConstants.GETALL_ACTIVE_ROLES_SUCCESS,
      activeRoles,
    };
  }
  function failure(error) {
    return {
      type: accessControlsConstants.GETALL_ACTIVE_ROLES_FAILURE,
      error,
    };
  }
}

function activateAccessRole(isActive, roleId) {
  return (dispatch) => {
    dispatch(request());
    accessControlsServices.activateAccessRole(isActive, roleId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return {
      type: accessControlsConstants.ACCESS_CONTROLS_ROLE_ACTIVATE_REQUEST,
    };
  }
  function success(data) {
    return {
      type: accessControlsConstants.ACCESS_CONTROLS_ROLE_ACTIVATE_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: accessControlsConstants.ACCESS_CONTROLS_ROLE_ACTIVATE_FAILURE,
      error,
    };
  }
}
//updateAccessControl
function updateAccessControl(formData, roleId) {
  return (dispatch) => {
    dispatch(request());
    accessControlsServices.updateAccessControl(formData, roleId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return {
      type: accessControlsConstants.UPDATE_ACCESS_CONTROLS_REQUEST,
    };
  }
  function success(data) {
    return {
      type: accessControlsConstants.UPDATE_ACCESS_CONTROLS_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: accessControlsConstants.UPDATE_ACCESS_CONTROLS_FAILURE,
      error,
    };
  }
}
//Delete Roles

function deleteRole(roleId) {
  return (dispatch) => {
    dispatch(request());
    accessControlsServices.deleteRole(roleId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: accessControlsConstants.DELETE_ROLE_REQUEST };
  }
  function success(data) {
    return { type: accessControlsConstants.DELETE_ROLE_SUCCESS, data };
  }
  function failure(error) {
    return { type: accessControlsConstants.DELETE_ROLE_FAILURE, error };
  }
}
//fetchAllUiNavigation
function fetchAllUiNavigation() {
  return (dispatch) => {
    dispatch(request())
    accessControlsServices.fetchAllUiNavigation().then(
      (navigationList) => dispatch(success(navigationList)),
      (error) => dispatch(failure(error.toString()))
    )
  }
  function request() {
    return { type: accessControlsConstants.FETCH_ALL_UI_NAVIGATION_REQUEST, }
  }
  function success(navigationList) {
    return { type: accessControlsConstants.FETCH_ALL_UI_NAVIGATION_SUCCESS, navigationList }
  }
  function failure(error) {
    return { type: accessControlsConstants.FETCH_ALL_UI_NAVIGATION_FAILURE, error }
  }
}
//assignUiNavigation
function assignUiNavigation(uiNavigation, roleId) {
  return (dispatch) => {
    dispatch(request());
    accessControlsServices.assignUiNavigation(uiNavigation, roleId).then(
      (assignUiNav) => {
        dispatch(success(assignUiNav));
        dispatch(alertActions.success(assignUiNav.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    )
  }
  function request() {
    return { type: accessControlsConstants.UPDATE_UI_NAVIGATION_REQUEST, }
  }
  function success(assignedUiNav) {
    return { type: accessControlsConstants.UPDATE_UI_NAVIGATION_SUCCESS, assignedUiNav }
  }
  function failure(error) {
    return { type: accessControlsConstants.UPDATE_UI_NAVIGATION_FAILURE, error }
  }
}
//UiNavigationById
function UiNavigationById(roleId){
  return (dispatch)=>{
    dispatch(request());
    accessControlsServices.UiNavigationById(roleId).then(
      (data)=>dispatch(success(data)),
      (error)=>dispatch(failure(error.toString()))
    )
  }
  function request(){
    return {type:accessControlsConstants.FETCH_UI_NAVIGATION_REQUEST,}
  }
  function success(data){
    return {type:accessControlsConstants.FETCH_UI_NAVIGATION_SUCCESS, data}
  }
  function failure(error){
    return {type:accessControlsConstants.FETCH_UI_NAVIGATION_FAILURE, error}
  }
}
// fetchPoliciesById
function fetchPoliciesById(roleId){
  return (dispatch)=>{
    dispatch(request());
    accessControlsServices.fetchPoliciesById(roleId).then(
      (policiesList)=>dispatch(success(policiesList)),
      (error)=>dispatch(failure(error.toString()))
    )
  }
  function request(){
    return { type:accessControlsConstants.FETCH_POLICIES_LIST_REQUEST,}
  }
  function success(policiesList){
    return { type:accessControlsConstants.FETCH_POLICIES_LIST_SUCCESS, policiesList}
  }
  function failure(error){
    return { type:accessControlsConstants.FETCH_POLICIES_LIST_FAILURE, error}
  }
}
//unassignUiNavigation
function unassignUiNavigation(uiNavigation, roleId){
  return (dispatch)=>{
    dispatch(request())
    accessControlsServices.unassignUiNavigation(uiNavigation, roleId).then(
      (unassign)=>{
        dispatch(success(unassign));
        dispatch(alertActions.success(unassign.message))
      },
      (error)=>{
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()))
      }
    )
  }
  function request(){
    return { type:accessControlsConstants.UNASSIGN_UI_NAVIGATION_REQUEST,}
  }
  function success(unassign){
    return { type:accessControlsConstants.UNASSIGN_UI_NAVIGATION_SUCCESS, unassign}
  }
  function failure(error){
    return { type:accessControlsConstants.UNASSIGN_UI_NAVIGATION_SUCCESS_FAILURE, error}
  }
}

function searchAccessControls(search, offset, limit) {
  return (dispatch) => {
    dispatch(request());
    accessControlsServices.searchAccessControls(search, offset, limit).then(
      (accessControls) => dispatch(success(accessControls)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: accessControlsConstants.GETALL_ACCESS_CONTROLS_REQUEST };
  }
  function success(accessControls) {
    return {
      type: accessControlsConstants.GETALL_ACCESS_CONTROLS_SUCCESS,
      accessControls,
    };
  }
  function failure(error) {
    return {
      type: accessControlsConstants.GETALL_ACCESS_CONTROLS_FAILURE,
      error,
    };
  }
}



